import React from 'react';
import { Facebook, Instagram, Twitter, Youtube } from 'lucide-react';

const Footer = () => {
    return (
        <footer className="bg-luxury-charcoal pt-20 pb-10 border-t border-luxury-gold/10">
            <div className="container mx-auto px-4 md:px-8">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
                    {/* Brand */}
                    <div className="col-span-1 md:col-span-1">
                        <div className="text-2xl font-serif font-bold tracking-widest text-luxury-black mb-6">
                            ALIGN
                        </div>
                        <p className="text-gray-600 text-sm leading-relaxed mb-6">
                            Elevating your style with timeless elegance and precision engineering.
                            Experience the art of luxury watchmaking.
                        </p>
                        <div className="flex space-x-4">
                            {[Facebook, Instagram, Twitter, Youtube].map((Icon, index) => (
                                <a key={index} href="#" className="text-gray-500 hover:text-luxury-gold transition-colors">
                                    <Icon className="w-5 h-5" />
                                </a>
                            ))}
                        </div>
                    </div>

                    {/* Links */}
                    <div>
                        <h4 className="text-luxury-black font-serif font-bold mb-6">Collections</h4>
                        <ul className="space-y-4 text-sm text-gray-600">
                            {['New Arrivals', 'Best Sellers', 'Limited Editions', 'Accessories'].map((item) => (
                                <li key={item}>
                                    <a href="#" className="hover:text-luxury-gold transition-colors">{item}</a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div>
                        <h4 className="text-luxury-black font-serif font-bold mb-6">Support</h4>
                        <ul className="space-y-4 text-sm text-gray-600">
                            {['Contact Us', 'FAQ', 'Shipping & Returns', 'Warranty'].map((item) => (
                                <li key={item}>
                                    <a href="#" className="hover:text-luxury-gold transition-colors">{item}</a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Newsletter */}
                    <div>
                        <h4 className="text-luxury-black font-serif font-bold mb-6">Newsletter</h4>
                        <p className="text-gray-600 text-sm mb-4">Subscribe to receive updates on new arrivals and special offers.</p>
                        <form className="flex flex-col space-y-3">
                            <input
                                type="email"
                                placeholder="Your email address"
                                className="bg-white border border-gray-200 px-4 py-3 text-sm text-luxury-black focus:outline-none focus:border-luxury-gold transition-colors"
                            />
                            <button className="btn-primary w-full">
                                Subscribe
                            </button>
                        </form>
                    </div>
                </div>

                <div className="border-t border-gray-200 pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-gray-500">
                    <p>&copy; 2024 Align. All rights reserved.</p>
                    <div className="flex space-x-6 mt-4 md:mt-0">
                        <a href="#" className="hover:text-luxury-black transition-colors">Privacy Policy</a>
                        <a href="#" className="hover:text-luxury-black transition-colors">Terms of Service</a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
